import { Button, ConfigProvider, Form, Input, message, Tooltip } from 'antd'
import {GithubLogo,EmailLogo, LinLogo} from '../img/LogoSvg'
import React, {  useRef, useState } from 'react'
import HCaptcha from "@hcaptcha/react-hcaptcha";

const { TextArea } = Input;

type ContactFormValues = {
  name: string;
  email: string;
  message: string;
};

const Contact = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const handleCopyClick = (emailText:string,msgText:string) => {
    navigator.clipboard.writeText(emailText)
      .then(() => messageApi.open({
        type: 'success',
        content: `${msgText} Copied!`,
        })
      )
      .catch(() =>  messageApi.open({
          type: 'error',
          content: 'Failed to copy!',
        })
      );
  };
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [captchaToken, setCaptchaToken] = useState<string | null>(null);
  const captchaRef = useRef<HCaptcha | null>(null);

  const handleCaptchaVerify = (token: string) => {
    setCaptchaToken(token);
  };

  const onFinish = async (values: ContactFormValues) => {
    if (!captchaToken) {
      message.error("Please complete the CAPTCHA.");
      return;
    }

    setLoading(true);

    const formData = new FormData();
    formData.append("access_key", process.env.REACT_APP_WEB3FORMS_KEY || "");
    formData.append("name", values.name);
    formData.append("email", values.email);
    formData.append("message", values.message);
    formData.append("h-captcha-response", captchaToken);

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (result.success) {
        // message.success("Message sent successfully!");
        messageApi.open({
          type: 'success',
          content: `Message sent successfully!`,
        })
        form.resetFields();
        captchaRef.current?.resetCaptcha();
        setCaptchaToken(null);
      } else {
        messageApi.open({
          type: 'error',
          content: `Failed to send message.`,
        })
        // console.log("Web3Forms result:", result);
      }
    } catch (error) {
      messageApi.open({
        type: 'error',
        content: "Something went wrong.",
      });
    } finally {
      setLoading(false);
    }
  };

  // const onFinishFailed: FormProps<FieldType>['onFinishFailed'] = (errorInfo:unknown) => {
  //   console.log('Failed:', errorInfo);
  // };

  return (
     <ConfigProvider
      theme={{
          components: {
            Form: {
                labelColor: '#3F4F44', // Custom label color
                itemMarginBottom: 16, // Custom margin between form items
                labelRequiredMarkColor: '#3F4F44', // Custom color for required mark
            },
          },
      }}
    >

    <div className='section-list'>
      {contextHolder}
      <h2 style={{paddingTop:"3%"}}>Contact me...</h2>
      <p style={{fontSize:"20px"}}>Get in touch with me to my email or other social media,</p>
      <div style={{ margin:"20px 0",display:'flex'}}>
        <Tooltip color='#3F4F44' title="Click to copy!">
          <div>
            <EmailLogo onClick={() => handleCopyClick("naufalghozi1100@gmail.com","Naufal Email")} style={{cursor:"pointer"}} />
          </div>
        </Tooltip>
        {/* <Tooltip color='#3F4F44' title="Click to copy!">
          <div>
            <WaLogo onClick={() => handleCopyClick("","Naufal Contact")} style={{cursor:"pointer"}} />
          </div>
        </Tooltip> */}
        <Tooltip color='#3F4F44' title="Click to visit this page!">
          <a href="https://github.com/falzee" target="_blank" rel="noopener noreferrer">
            <GithubLogo style={{cursor:"pointer",textDecoration:"none"}} />
          </a>
        </Tooltip>
        <Tooltip color='#3F4F44' title="Click to visit this page!">
          <a href="https://www.linkedin.com/in/muhammad-naufal-ghozi-a01233196" target="_blank" rel="noopener noreferrer">
            <LinLogo style={{cursor:"pointer",textDecoration:"none"}} />
          </a>
        </Tooltip>
      </div>

      <p style={{fontSize:"20px"}}>or leave a message here!</p>

      <div style={{ position: "relative", margin: "0 -10px" }}>

        {/* Form content */}
        <div style={{
          zIndex: 10000,
          padding: "10px",
          position: "relative",
        }}>
          <Form layout="vertical" onFinish={onFinish} requiredMark="optional" form={form}>
            <Form.Item
              label="Name* : "
              name="name"
              rules={[{ required: true, message: "Please enter your name!" }]}
            >
              <Input placeholder="Enter your name!" />
            </Form.Item>

            <Form.Item
              label="E-mail or contact* : "
              name="email"
              rules={[{ required: true, message: "Please enter your e-mail or contact!" }]}
            >
              <Input placeholder="Enter your e-mail or contact!" />
            </Form.Item>

            <Form.Item
              label="Message* : "
              name="message"
              rules={[{ required: true, message: "Please enter your message!" }]}
            >
              <TextArea
                rows={4}
                placeholder="Your message and advice are always appreciated!"
              />
            </Form.Item>

            <Form.Item>
              <HCaptcha
                sitekey={process.env.REACT_APP_HCAPTCHA_SITEKEY || ""}
                onVerify={handleCaptchaVerify}
                ref={captchaRef}
              />
            </Form.Item>

            <Form.Item style={{ textAlign: "center" }}>
              <Button
                htmlType="submit"
                loading={loading}
                style={{
                  width: "130px",
                  height: "40px",
                  fontSize: "18px",
                }}
              >
                Submit
              </Button>
            </Form.Item>
          </Form>
          </div>
        </div>
    </div>
  </ConfigProvider>

  )
}

export default Contact
